export default __webpack_public_path__ + "b01a6fe63a6d7eab8f599f1776786af5.svg";